<template>
  <v-container>
    <div v-if="!showPreview">
      <div class="d-flex justify-space-around justify-center font-weight-bold text--darken-4 my-4">{{$t('lang.query')}}</div>
      <v-row class="d-flex justify-space-around justify-center">
        <v-col cols="12" sm="12">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.registrationNumber')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{obj.SignUpNo}}</td>
                </tr>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.conferencTopics')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{$store.getters.getLanguage === 0 ? obj.SignUpName : data.EnglishSubject}}</td>
                </tr>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.participant')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{obj.UserName}}</td>
                </tr>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.registrationPhoneOrEmail')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{obj.Phone}}</td>
                </tr>
                <tr v-if="obj.MemberList && obj.MemberList.length > 1">
                  <td class="black--text text--darken-2 text-subtitle-1">同一单位多人报名</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">是，{{obj.MemberList.length}}人</td>
                </tr>
                <!-- <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.status')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{state}}</td>
                </tr> -->
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.submissionTime')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{obj.SignUpTime}}</td>
                </tr>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.paymentStatus')}}</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{payState}}</td>
                </tr>
                <tr>
                  <td class="black--text text--darken-2 text-subtitle-1">缴费金额</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">{{obj.PayMoney}}元</td>
                </tr>
                <tr v-if="obj.TaxFileUrl && obj.TaxFileUrl !== ''">
                  <td class="black--text text--darken-2 text-subtitle-1">发票文件</td>
                  <td class="grey--text text--darken-2 text-subtitle-1">
                    <v-btn text color="primary" style="text-transform:none;padding: 0px;" :href="obj.TaxFileUrl">下载发票</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <div class="d-flex justify-space-around justify-center">
        <v-btn color="primary" style="text-transform:none;" @click="$emit('fatherEvent', 'back')">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" :href="obj.DownloadUrl">{{$t('lang.download')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="showPreview=true">{{$t('lang.preview')}}</v-btn>
      </div>
      <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    </div>
    <Preview v-if="showPreview" :data="obj" @fatherEvent="showPreview=false"></Preview>
  </v-container>
</template>
<script>
import Preview from '@/components/Preview'
export default {
  name: 'Query',
  props: ['data'],
  components: {
    Preview
  },
  data () {
    return {
      showPreview: false,
      snackbar: false,
      msg: '',
      obj: {}
    }
  },
  computed: {
    state () {
      let state = ''
      switch (this.obj.State) {
        case 1:
          state = this.$store.getters.getLanguage === 0 ? '待审' : 'Under review'
          break
        case 2:
          state = this.$store.getters.getLanguage === 0 ? '通过' : 'Pass'
          break
        case 3:
          state = this.$store.getters.getLanguage === 0 ? '未通过' : 'Not pass'
          break
        case 4:
          state = this.$store.getters.getLanguage === 0 ? '已导入' : 'Imported'
          break
        case 5:
          state = this.$store.getters.getLanguage === 0 ? '已支付' : 'Paid'
          break
        default:
          break
      }
      return state
    },
    payState () {
      let state = ''
      switch (this.obj.PayState) {
        case 1:
          state = this.$store.getters.getLanguage === 0 ? '未缴费' : 'Not paid yet'
          break
        case 2:
          state = this.$store.getters.getLanguage === 0 ? '微信已缴' : 'Paid（Wechat）'
          break
        case 3:
          state = this.$store.getters.getLanguage === 0 ? '转账已缴' : 'Paid（Transfer）'
          break
        case 4:
          state = this.$store.getters.getLanguage === 0 ? '其它已缴' : 'Paid'
          break
        case 5:
          state = this.$store.getters.getLanguage === 0 ? '已开发票' : 'Invoiced'
          break
        case 6:
          state = this.$store.getters.getLanguage === 0 ? '已退费' : 'Refunded'
          break
        default:
          break
      }
      return state
    }
  },
  mounted () {
    this.query()
  },
  methods: {
    query () {
      this.$http.get('/SignUp/SearchUserSignup', {
        requestBase: 'VUE_APP_API',
        params: {
          UserName: this.$store.getters.getUserName,
          Phone: this.$store.getters.getPhoneOrEmail,
          SignUpId: this.$store.getters.getSignUpId
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res)
          this.obj = res.data.data
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    }
  }
}
</script>
